(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["powerlete-card-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pwCardSwatchesBound) return;
    window.__pwCardSwatchesBound = true;

    function getCardImg(swatchEl) {
      var card = swatchEl.closest('product-card, .pw-ctl__card, .pw-rv__card, .pw-predictive-card');
      if (!card) return null;
      var area = card.querySelector('[data-card-img-area]');
      return area ? area.querySelector('img') : null;
    }

    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest('.pw-cs__btn');
      if (!btn) return;
      var url = btn.dataset.swatchImg;
      if (!url) return;
      var img = getCardImg(btn);
      if (!img) return;
      if (!img.dataset.pwOrigSrc) img.dataset.pwOrigSrc = img.src;
      if (img.dataset.pwOrigSrcset === undefined) {
        img.dataset.pwOrigSrcset = img.getAttribute('srcset') || '';
      }
      img.src = url;
      img.removeAttribute('srcset');
    });

    document.addEventListener('mouseout', function (e) {
      var btn = e.target.closest('.pw-cs__btn');
      if (!btn) return;
      if (btn.contains(e.relatedTarget)) return;
      var img = getCardImg(btn);
      if (!img || !img.dataset.pwOrigSrc) return;
      img.src = img.dataset.pwOrigSrc;
      var orig = img.dataset.pwOrigSrcset;
      if (orig) img.setAttribute('srcset', orig);
      else img.removeAttribute('srcset');
      delete img.dataset.pwOrigSrc;
      delete img.dataset.pwOrigSrcset;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["powerlete-quick-add-opener"] && !Shopify.designMode) return;
  try {
    if (!window.__pqaOpenerBound) {
    window.__pqaOpenerBound = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-pqa-open]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (window.powerleteQuickAdd) {
        const listName = btn.closest('[data-list-name]')?.dataset.listName || '';
        // Native <dialog> renders in the browser top layer, above all fixed elements.
        // Close any open dialog-component first so the sheet isn't hidden behind it.
        const dlgComponent = btn.closest('dialog-component');
        if (dlgComponent?.closeDialog) {
          dlgComponent.closeDialog();
        } else {
          btn.closest('dialog')?.close();
        }
        window.powerleteQuickAdd.open(btn.dataset.handle, listName);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["powerlete-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('powerlete-quick-add')) {
    // Clear the per-button loading state once the cart responds (success or error).
    var pwqaClearAdding = function () {
      document.querySelectorAll('.powerlete-qa__size.is-adding').forEach(function (b) {
        b.classList.remove('is-adding');
      });
    };
    document.addEventListener('cart:update', pwqaClearAdding);
    document.addEventListener('cart:error', pwqaClearAdding);

    customElements.define('powerlete-quick-add', class extends HTMLElement {
      connectedCallback() {
        // Look up form/input at click time, NOT here. This element is defined once
        // (first card's inline script); every later card is already-defined when the
        // parser creates it, so connectedCallback fires before the <form> child is
        // parsed. A reference captured now would be null on all cards but the first,
        // and form.requestSubmit() would silently never run.
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('.powerlete-qa__size');
          if (!btn || btn.getAttribute('aria-disabled')) return;
          e.preventDefault();
          e.stopPropagation();
          // Ignore repeat clicks while an add from this panel is already in flight.
          if (this.querySelector('.powerlete-qa__size.is-adding')) return;
          const form = this.querySelector('form');
          const vidInput = this.querySelector('[data-vid-input]');
          if (vidInput) vidInput.value = btn.dataset.vid;
          // Instant feedback: the add round-trip can take ~0.5-1s, so show a spinner
          // on the clicked size right away. Cleared by the cart:update/cart:error
          // listeners above; the timeout is a safety net if neither event fires.
          btn.classList.add('is-adding');
          setTimeout(() => btn.classList.remove('is-adding'), 6000);
          if (form) form.requestSubmit();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
